import { InnerBlocks } from '@wordpress/block-editor';

export default function TermTemplateSave() {
	return <InnerBlocks.Content />;
}
